import theme from '@gaia/theme';
import {CircularProgress} from '@mui/material';

export default function SidebarLoading() {
    return (
        <div
            style={{
                width: '100%',
                marginTop: theme.spacing(3),
                marginBottom: theme.spacing(3),
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <CircularProgress thickness={7} size={24} disableShrink />
        </div>
    );
}
